<ul nz-menu>
  @for (userResource of userResources; track userResource.id) {
    <li
      nz-menu-item
      [nzSelected]="userResource.isCurrent"
      (click)="switch(userResource)"
      [nzDisabled]="userResource.isLocked"
    >
      {{ userResource.role }}
      @if (userResource.isLocked) {
        <i appIcon="lock"></i>
      }
      <br />{{ userResource.person.firstName }} {{ userResource.person.lastName }} -
      {{ userResource?.company?.station?.extended | safeNull }}
    </li>
  }
</ul>
